import { render, staticRenderFns } from "./certificate.vue?vue&type=template&id=160b9b47&scoped=true&"
import script from "./certificate.vue?vue&type=script&lang=js&"
export * from "./certificate.vue?vue&type=script&lang=js&"
import style0 from "./certificate.vue?vue&type=style&index=0&id=160b9b47&scoped=true&lang=css&"
import style1 from "./certificate.vue?vue&type=style&index=1&id=160b9b47&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160b9b47",
  null
  
)

export default component.exports